import moment from 'moment-timezone';
import config from "../../config";
const timeZone = process.env.TIME_ZONE || 'Asia/Kathmandu';

export function formatDateTime(dateInput) {
    return moment(dateInput)
        .tz(timeZone)
        .format('DD MMM YYYY, hh:mm:ss A');
}

export  const handleContactCall = async (number, contact_id, campaignId, type = '', isCall = 1) => {
    const token = localStorage.getItem("token");
    try {
        const response = await fetch(
            `${config.callApiBaseUrl}/api/v1/contacts/numbers/${number}/call?camp_id=${campaignId}&type=${type}&is_call=${isCall}`,
            {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({contact_id:contact_id}),
            }
        );

        const data = await response.json();
        return data;

    } catch (error) {

      throw error;

    }
  };

  export   const formatHoldTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };

  export const parseDate = (dateStr) => {
    if(!dateStr) return null;
    const parsedDate = new Date(dateStr.replace(' ', 'T')); // Replace space with 'T' for ISO format
    return isNaN(parsedDate) ? null : parsedDate;
  };

  